<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="authors-note">
<h1>Author’s Note</h1>
<p>I have been raised in a financially insecure household. I have hit rock bottom twice. I have been unemployed. I have been rejected countless times. I have prioritized everyone else before myself. I have felt afraid, empty, purposeless, not good enough and unwanted.</p>
<p>Despite this, I am also an executive who has been lucky enough to work in some of the most prestigious firms in the financial and management consulting industry across Asia and Europe. And I am extremely fortunate to have had the opportunity to create unique ways to care for myself and my clients so we can serve the world in our own fulfilling ways.</p>
<p>I am blessed to have loving, lasting relationships with my family and friends. And I am grateful to be happily married with love of my life Alain, for 21 years.</p>
<p>I believe in love, infinite human potential and that a fulfilling life can be a reality not a dream. That is why I am a nurturer on a mission to create a world where everyone feels loved, nurtures one’s full potential by putting self-care first and lives a meaningful life by serving the world to make it a better place in one’s own fulfilling way. So, join me on this incredible journey of empowerment and if you want to be part of a community that is positive, loving and nurturing, this is here. </p>
<p>To learn more, please visit https://nurturing.ch/ and follow us on social media @nurturing_youareloved</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?aac6c51a